import { Play } from '@phosphor-icons/react';
import { AnimatedDemo } from '../AnimatedDemo';

export const DemoSection = () => {
  return (
    <section id="demo" className="py-24 px-6 bg-[#09090B]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 text-white text-sm font-medium mb-6">
            <Play size={18} weight="fill" />
            Live Demo
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-white mb-4">
            See It In Action
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto">
            Watch how DashLink Gaming brings your gaming community together with real-time features.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <AnimatedDemo />
        </div>
      </div>
    </section>
  );
};
